<div *ngIf="value != null" class="container">
    <ng-container *ngIf="!executeAsPolice && (optionExpanded=='' || optionExpanded==null)">
        <div class="block-title">
            <div class="title"> {{ 'SHARED.EXTERNAL.CMR.ACTIONS.POLICEINSPECTION.CAPTION' | translate }} </div>
        </div>
        
        <shared-cmr-qr-component [agent]="'police'" [uuidQR]="value.uuidQR"></shared-cmr-qr-component>

        <div class="action-card card-police" (click)="executeAsPolice = true">
            <div class="icon-wrapper">
                <i class="fa fa-external-link-square" aria-hidden="true"></i>
            </div>
            <div class="card-body">
                <div class="card-title">{{'SHARED.EXTERNAL.CMR.ACTIONS.POLICEINSPECTION.TOEXECUTEASPOLICE.CAPTION' | translate }}</div>
            </div>
            <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
        </div>
    </ng-container>
    <ng-container *ngIf="executeAsPolice">
        <shared-external-cmr-agent-police-qr-component [agent]="'police'" [uuidQR]="value.uuidQR" [optionExpanded]="optionExpanded" (optionExpandedChanged)="onOptionExpandedChanged($event)"></shared-external-cmr-agent-police-qr-component>
    </ng-container>
</div>